'use client'

import { Title, Text, Stack, Anchor } from '@mantine/core'

export default function EarlyAccessSection() {
  return (
    <Stack 
      gap="md" 
      align="center" 
      style={{ 
        textAlign: 'center', 
        maxWidth: '800px', 
        margin: '0 auto',
        paddingTop: '3rem'
      }}
    >
      <Title order={2} size="h1" className="gradient-emerald">
        Built for Real Mentorship
      </Title>

      <Text size="lg" c="gray.7" style={{ lineHeight: 1.7 }}>
        We&apos;re building a platform that respects your time and makes mentorship work for busy professionals. Whether you&apos;re a first-time mentor or experienced guide, we&apos;re here to make it easier.
      </Text>

      <Text size="lg" c="gray.7" style={{ lineHeight: 1.7 }}>
        Have feedback or ideas?{' '}
        <Anchor href="mailto:support@mentorsub.com" c="navy" fw={500}>
          We&apos;d love to hear from you
        </Anchor>
      </Text>
    </Stack>
  )
}
